module.exports = __webpack_public_path__ + "img/score9.199564bd.png";